function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedTrainingClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16.1 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 57",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#0F1177",
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.494H5.95V5.95H19.828v1.931H18.838V6.94h-11.9v10.566H16V18.495zm2.889-6.222a1.83 1.83 0 0 1-1.828-1.828 1.83 1.83 0 0 1 1.828-1.827 1.83 1.83 0 0 1 1.828 1.827 1.83 1.83 0 0 1-1.828 1.828zm0-2.666a.84.84 0 0 0 0 1.677.84.84 0 0 0 0-1.677z",
    style: {
      stroke: "none"
    },
    transform: "translate(-5.9 -5.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6v12.444h9.95v-.889H6.889V6.89h12v.942h.889V6H6m12.889 2.667a1.778 1.778 0 1 0 0 3.555 1.778 1.778 0 0 0 0-3.555m0 2.666a.889.889 0 1 1 0-1.777.889.889 0 0 1 0 1.777M6 5.9h13.778a.1.1 0 0 1 .1.1v1.831a.1.1 0 0 1-.1.1h-.89a.1.1 0 0 1-.1-.1V6.99h-11.8v10.466h8.962a.1.1 0 0 1 .1.1v.89a.1.1 0 0 1-.1.1H6a.1.1 0 0 1-.1-.1V6a.1.1 0 0 1 .1-.1zm12.889 2.667a1.88 1.88 0 0 1 1.878 1.877 1.88 1.88 0 0 1-1.878 1.878 1.88 1.88 0 0 1-1.878-1.878 1.88 1.88 0 0 1 1.878-1.877zm0 2.666a.79.79 0 0 0 0-1.577.79.79 0 0 0 0 1.577z",
    style: {
      fill: "#0F1177",
      stroke: "none"
    },
    transform: "translate(-5.9 -5.9)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58",
    d: "M24.707 21.369a1.333 1.333 0 0 1 .92-.369h1.814a2.469 2.469 0 0 1 1.723.662 2.693 2.693 0 0 1 .778 1.483 4.056 4.056 0 0 1-.388 2.479v3.6a1.111 1.111 0 0 1-2.207.183l-.237-1.424-.237 1.417a1.111 1.111 0 0 1-2.207-.183v-4.176a1.333 1.333 0 0 1-.666.179h-2.269a1.333 1.333 0 1 1 0-2.667h1.734zm.848 5.176V29.222a.222.222 0 0 0 .441.037l.463-2.781a.444.444 0 0 1 .438-.371h.425a.444.444 0 0 1 .438.371l.463 2.781a.222.222 0 0 0 .441-.037v-3.7a.444.444 0 0 1 .05-.2 3.2 3.2 0 0 0 .353-2.007 1.807 1.807 0 0 0-.515-1 1.581 1.581 0 0 0-1.113-.42h-1.812a.445.445 0 0 0-.307.123l-1.37 1.301a.445.445 0 0 1-.307.123h-1.912a.444.444 0 1 0 0 .889H24a.445.445 0 0 0 .307-.123l.5-.475a.444.444 0 0 1 .751.322z",
    transform: "translate(-13.899 -14.233)",
    style: {
      fill: "#0F1177",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedTrainingClass);
export default __webpack_public_path__ + "static/media/detailed-training-class.8fb1ad45124efc9e02b2ed1ba1385a19.svg";
export { ForwardRef as ReactComponent };